import MainLayout from "../../layouts/MainLayOut";

function Privacy() {
  const sections = [
    {
      title: "Introduction",
      content: `Token AI Labs Pvt Ltd. (“we,” “our,” or “us”) respects your privacy and is committed to protecting the information you share with us through Jaano (the “Service”), accessible at www.jaano.com. This Privacy Policy explains what data we collect, how we use it, and the rights you have over your data.`,
    },
    {
      title: "Types of Data Collected",
      list: [
        `<strong>User-Provided Data:</strong> Users upload content (PDFs, websites) to customize their chatbot. This data is used solely for that purpose.`,
        `<strong>Automatically Collected Data:</strong> Includes IP address, browser type, OS, and interaction metrics, collected via cookies.`,
        `<strong>Sensitive Personal Data:</strong> We do not require or store sensitive data. Users are advised not to upload such information.`,
      ],
    },
    {
      title: "Purpose of Data Collection",
      content: `We collect and process data to:`,
      list: [
        "Enable you to create and customize chatbots.",
        "Improve performance and personalize experience.",
        "Provide customer support.",
        "Comply with legal requirements.",
      ],
    },
    {
      title: "Data Storage and Retention",
      list: [
        `<strong>Storage Location:</strong> Secured third-party cloud servers with strong encryption.`,
        `<strong>Retention Period:</strong> Data is retained only as long as necessary. Users may delete their data anytime via the Jaano interface.`,
        `<strong>Access:</strong> For technical support, we reserve the rights to access the account from the backend.`,
      ],
    },
    {
      title: "Data Security Measures",
      list: [
        "Data encryption in transit and at rest.",
        "Role-based access control for authorized personnel only.",
        "Regular audits and security updates.",
      ],
    },
    {
      title: "Data Sharing and Disclosure",
      content: `We do not sell or share user data. We may use third-party vendors for storage or processing, bound by strict data protection.`,
      list: [
        "To comply with legal obligations or public authorities.",
        "To protect our rights and ensure security.",
      ],
    },
    {
      title: "User Rights",
      content: `Users have the right to:`,
      list: [
        `<strong>Access:</strong> Review their stored data.`,
        `<strong>Correction:</strong> Fix inaccuracies.`,
        `<strong>Deletion:</strong> Remove all personal data.`,
        `<strong>Restriction:</strong> Limit how data is processed.`,
      ],
    },
    {
      title: "Processing of Uploaded Content",
      content: `Documents and websites are processed only to train your chatbot. Data is never reused or shared externally without consent.`,
    },
    {
      title: "Cookies and Tracking",
      content: `Jaano uses cookies to store preferences and enhance experience. Disabling cookies may impact functionality.`,
    },
    {
      title: "International Data Transfers",
      content: `If data is processed outside India, it is protected by strict contracts. We ensure strong compliance and security regardless of location.`,
    },
  ];

  return (
    <MainLayout>
      <div className="flex flex-col">
        <div
          className="flex-1 px-4 py-10 md:pt-20 sm:px-10 md:px-20 lg:px-28 2xl:px-[10vw] text-slate-300 gap-8 flex flex-col"
          style={{
            background:
              "radial-gradient(circle, rgba(51, 65, 85, 1) 1%, rgba(2, 6, 23, 1) 92%)",
          }}>
          <div className="space-y-3">
            <h1 className="text-slate-50 font-bold text-3xl sm:text-4xl 2xl:text-[5vw] 2xl:leading-[5.5vw]">
              Privacy Policy
            </h1>
            <p className="text-base sm:text-lg 2xl:text-[1.2vw] 2xl:leading-[1.5vw] text-slate-400">
              Welcome to{" "}
              <span className="text-slate-200 font-medium">
                Token AI Labs Pvt. Ltd.
              </span>
              ! This Privacy Policy explains how we collect, use, and protect
              your information when you use our chatbot product,{" "}
              <span className="text-slate-100 font-semibold">Jaano</span>.
            </p>
          </div>

          <div className="flex flex-col gap-6">
            {sections.map((sec, i) => (
              <div
                key={i}
                className="flex flex-col gap-3 bg-slate-900/60 border border-slate-800 rounded-2xl p-5 md:p-6 2xl:p-10 backdrop-blur-sm shadow-inner">
                <h2 className="text-xl sm:text-2xl 2xl:text-[1.4vw] font-semibold text-slate-100">
                  {i + 1}. {sec.title}
                </h2>
                {sec.content && (
                  <p
                    className="text-sm sm:text-base 2xl:text-[1.1vw] text-slate-400 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: sec.content }}
                  />
                )}
                {sec.list && (
                  <ul className="list-disc list-inside pl-3 text-sm sm:text-base 2xl:text-[1.1vw] text-slate-300 space-y-2">
                    {sec.list.map((li, idx) => (
                      <li key={idx} dangerouslySetInnerHTML={{ __html: li }} />
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>

          {/* Contact Section */}
          <div className="border-t border-slate-800 pt-6 text-slate-400 text-sm 2xl:text-[1vw]">
            <p className="mb-2">
              For privacy inquiries, contact us at{" "}
              <a
                href="mailto:info@jaano.ai"
                className="text-slate-200 hover:underline">
                info@jaano.ai
              </a>
            </p>
            <p className="mb-1 font-medium text-slate-300">
              Token AI Labs Pvt. Ltd.
            </p>
            <p>
              415 Krushal Comm. Complex, Above Westside, G M Road, Chembur,
              Mumbai 400089. India
            </p>
            <a
              href="https://www.tokenailabs.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-200 hover:underline">
              www.tokenailabs.com
            </a>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default Privacy;
